import { pressQuotes } from '@/mocks/home';
import SectionHeading from './SectionHeading';

export default function Press() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-shell px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-3 lg:gap-14">
          <div>
            <SectionHeading
              id="press"
              kicker="05 / PRESS"
              title="负面新闻摘录"
              desc="站内之外，也有不少文字从旁观者的角度记录过这些节点。下面几段按时间排列，原文出处一并标出。"
            />
          </div>

          <div className="lg:col-span-2">
            <ul className="divide-y divide-background-200 border-t border-background-200">
              {pressQuotes.map((item) => (
                <li key={item.id} data-reveal className="group py-6 first:pt-0">
                  <div className="flex items-start gap-5">
                    <span className="mt-1 flex h-9 w-9 flex-none items-center justify-center rounded-full bg-accent-100 text-accent-700">
                      <i className="ri-double-quotes-l text-base" />
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="font-heading text-base leading-8 text-foreground-900 md:text-lg md:leading-9">
                        {item.quote}
                      </p>
                      <div className="mt-3 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                        <span className="flex items-center gap-1.5">
                          <i className="ri-newspaper-line text-sm" />
                          {item.source}
                        </span>
                        <span className="h-1 w-1 rounded-full bg-foreground-300" />
                        <span>{item.date}</span>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
            <p className="mt-6 text-xs leading-6 text-foreground-400">
              以上内容为公开讨论的整理摘录，仅作信息聚合，不代表本站观点。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}